import { Component, OnInit, QueryList, ViewChildren, input, output } from '@angular/core';
import { AdWriteDownAttribute } from '../../../../../../shared/models/generated/ziroModels';
import { AdAttributeChildFormComponent } from './ad-attribute-child-form/ad-attribute-child-form.component';
import { ZiroFormsUpdate } from '../../../../../../forms/ziro-forms-models';
import { ZiroIcons } from '../../../../../../shared/models/ziro-icons.enum';
import { ButtonSizes, ButtonStyles } from '../../../../../../button/button.component';

@Component({
  selector: 'ziro-ad-attributes',
  templateUrl: './ad-attributes.component.html',
  standalone: false,
})
export class AdAttributesComponent implements OnInit {
  @ViewChildren(AdAttributeChildFormComponent) adAttributeChildren: QueryList<AdAttributeChildFormComponent>;
  readonly adItemWasChanged = output<void>();
  readonly initialAdAttributes = input<AdWriteDownAttribute[]>();
  readonly dynamicPreviewValue = input<string>();
  adAttributes: AdWriteDownAttribute[] = [];
  allAttributeNames: string[];

  ngOnInit(): void {
    const initialAdAttributes = this.initialAdAttributes();
    if (!initialAdAttributes || !initialAdAttributes.length) {
      this.adAttributes = [].concat({
        attributeName: '',
        attributeValue: '',
        show: false,
        required: true,
      });
    } else {
      this.adAttributes = initialAdAttributes;
    }
  }

  onChildFormUpdate(event: ZiroFormsUpdate<AdWriteDownAttribute>): void {
    if (event.new !== event.old) {
      this.adItemWasChanged.emit();
      this.allAttributeNames = this.getAllChildValues().map((childValue) => childValue.attributeName);
    }
  }

  areAllItemsValid(): boolean {
    return !this.adAttributeChildren.some((child) => !child.isFormValid());
  }

  validateAllChildren(): void {
    this.adAttributeChildren.forEach((child) => child._validateAndSubmitSource.next(true));
  }

  handleClearClicked(index: number): void {
    this.adAttributes = [...this.adAttributeChildren.map((child) => child.formData).filter((_, idx) => idx !== index)];
    this.allAttributeNames = this.getAllChildValues()
      .map((childValue) => childValue.attributeName)
      .filter((_, idx) => idx !== index);
    this.adItemWasChanged.emit();
  }

  handleAddItemClicked(): void {
    this.adAttributes = this.adAttributes.concat({
      attributeName: '',
      attributeValue: '',
      show: false,
      required: true,
    });
  }

  getAllChildValues(): AdWriteDownAttribute[] {
    return this.adAttributeChildren.map((child) => child.formData);
  }

  protected readonly ziroIcons = ZiroIcons;
  protected readonly buttonSizes = ButtonSizes;
  protected readonly buttonStyles = ButtonStyles;
}
